webpackJsonp([27362984104999],{

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n  grid-gap: 0.5rem;\n  grid-auto-rows: ', ';\n  grid-auto-flow: dense;\n'], ['\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(', ', 1fr));\n  grid-gap: 0.5rem;\n  grid-auto-rows: ', ';\n  grid-auto-flow: dense;\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _List = __webpack_require__(62);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _utils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Gallery = (0, _styledComponents2.default)(_List2.default)(_templateObject, (0, _utils.pxToRem)(300), (0, _utils.pxToRem)(260));
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: transform 0.3s ease-in;\n  transform: translateY(100%);\n\n  @media (hover: none) {\n    transform: translateY(0);\n  }\n\n  p,\n  h4 {\n    margin-bottom: 0;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n\n    background-color: ', ';\n    text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);\n    font-weight: ', ';\n  }\n\n  h4 {\n    text-transform: uppercase;\n  }\n'], ['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: transform 0.3s ease-in;\n  transform: translateY(100%);\n\n  @media (hover: none) {\n    transform: translateY(0);\n  }\n\n  p,\n  h4 {\n    margin-bottom: 0;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n\n    background-color: ', ';\n    text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);\n    font-weight: ', ';\n  }\n\n  h4 {\n    text-transform: uppercase;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _tinycolor = __webpack_require__(27);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	var _vars = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryCopy = _styledComponents2.default.div(_templateObject, (0, _tinycolor2.default)('#fff').setAlpha(0.6).toRgbString(), _vars.BODY_WEIGHTS.medium);
	
	exports.default = GalleryCopy;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n    width: 100%;\n  }\n\n  &:hover,\n  &:focus {\n    ', ' {\n      transform: translateY(0);\n    }\n  }\n'], ['\n  position: relative;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n    width: 100%;\n  }\n\n  &:hover,\n  &:focus {\n    ', ' {\n      transform: translateY(0);\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GalleryCopy = __webpack_require__(289);
	
	var _GalleryCopy2 = _interopRequireDefault(_GalleryCopy);
	
	var _propTypes = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GalleryItem = function GalleryItem(_ref) {
	  var Tag = _ref.tag,
	      rest = _objectWithoutProperties(_ref, ['tag']);
	
	  return _react2.default.createElement(Tag, rest);
	};
	
	GalleryItem.displayName = 'GalleryItem';
	
	GalleryItem.propTypes = {
	  tag: CustomPropTypes.Tag
	};
	
	GalleryItem.defaultProps = {
	  tag: 'div'
	};
	
	exports.default = (0, _styledComponents2.default)(GalleryItem)(_templateObject, _GalleryCopy2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n'], ['\n  &:not(:last-child) {\n    margin-bottom: 0;\n  }\n']);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ListItem = __webpack_require__(63);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryItemWrapper = (0, _styledComponents2.default)(_ListItem2.default)(_templateObject);
	
	exports.default = GalleryItemWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n'], ['\n  height: 100%;\n  z-index: 1;\n  transition: transform 3s;\n\n  &:hover {\n    transform: scale(1.15);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n'], ['\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ZoomImage = (0, _styledComponents2.default)(_GatsbyImage2.default)(_templateObject);
	
	var ZoomImageWrapper = function ZoomImageWrapper(_ref) {
	  var className = _ref.className,
	      rest = _objectWithoutProperties(_ref, ['className']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(ZoomImage, rest)
	  );
	};
	
	ZoomImageWrapper.displayName = 'ZoomImageWrapper';
	
	ZoomImageWrapper.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _styledComponents2.default)(ZoomImageWrapper)(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n'], ['\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageContainer = __webpack_require__(116);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _Gallery = __webpack_require__(305);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _GalleryItemWrapper = __webpack_require__(307);
	
	var _GalleryItemWrapper2 = _interopRequireDefault(_GalleryItemWrapper);
	
	var _GalleryCopy = __webpack_require__(289);
	
	var _GalleryCopy2 = _interopRequireDefault(_GalleryCopy);
	
	var _ZoomImage = __webpack_require__(138);
	
	var _ZoomImage2 = _interopRequireDefault(_ZoomImage);
	
	var _GalleryItem = __webpack_require__(306);
	
	var _GalleryItem2 = _interopRequireDefault(_GalleryItem);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _gallery = __webpack_require__(416);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GalleryPage = function GalleryPage(_ref) {
	  var className = _ref.className,
	      data = _ref.data;
	
	  if (!data.gallery || !data.galleryMeta) {
	    return null;
	  }
	
	  var landingGallery = (0, _gallery.composeGalleryLandingMedia)(data.gallery.edges, data.galleryMeta.edges);
	  return _react2.default.createElement(
	    _PageContainer2.default,
	    { tag: 'section', className: className },
	    _react2.default.createElement(
	      _Gallery2.default,
	      null,
	      landingGallery.map(function (media) {
	        return _react2.default.createElement(
	          _GalleryItemWrapper2.default,
	          { key: media.id },
	          _react2.default.createElement(
	            _GalleryItem2.default,
	            { tag: _gatsbyLink2.default, to: media.href, 'aria-label': media.name + ' project details' },
	            _react2.default.createElement(_ZoomImage2.default, { sizes: media.sizes }),
	            _react2.default.createElement(
	              _GalleryCopy2.default,
	              null,
	              _react2.default.createElement(
	                'h4',
	                null,
	                media.name
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                media.location
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	GalleryPage.displayName = 'GalleryPage';
	
	GalleryPage.propTypes = {
	  data: _propTypes2.default.shape({
	    gallery: CustomPropTypes.AllImageSharp,
	    galleryMeta: CustomPropTypes.AllGalleryMeta
	  }).isRequired,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _styledComponents2.default)(GalleryPage)(_templateObject);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var predicate = function predicate(primaryMatch) {
	  return function (include) {
	    return function (edge) {
	      if (edge.node.id.includes(primaryMatch)) {
	        return include;
	      }
	      return !include;
	    };
	  };
	};
	
	var mapEdgeToNode = exports.mapEdgeToNode = function mapEdgeToNode(edge) {
	  return edge.node;
	};
	
	var edgesToGallery = exports.edgesToGallery = function edgesToGallery(edges) {
	  var primaryMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var predicateMatch = predicate(primaryMatch);
	  var primary = edges.find(predicateMatch(true));
	
	  if (primary) {
	    return {
	      primaryImage: mapEdgeToNode(primary),
	      additionalImages: edges.filter(predicateMatch(false)).map(mapEdgeToNode)
	    };
	  }
	
	  return {
	    primaryImage: null,
	    additionalImages: edges.map(mapEdgeToNode)
	  };
	};
	
	var composeGalleryLandingMedia = exports.composeGalleryLandingMedia = function composeGalleryLandingMedia(images, contentMeta) {
	  return images.reduce(function (acc, image) {
	    // check to see if each image exists in the contentMeta...
	    var matchContent = contentMeta.find(function (meta) {
	      return !!image.node.id.match(meta.node.frontmatter.coverPhoto.substr(0, meta.node.frontmatter.coverPhoto.length - 1));
	    });
	    if (!matchContent) {
	      return acc;
	    }
	    var media = _extends({
	      id: matchContent.node.id,
	      href: matchContent.node.fields.slug,
	      location: matchContent.node.frontmatter.location,
	      name: matchContent.node.frontmatter.name,
	      imageId: image.node.id,
	      sizes: image.node.sizes
	    });
	    acc.push(media);
	    return acc;
	  }, []);
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gallery-js-9106a4aac36f61220056.js